import type { Prototype } from "../prototype-types";

export const pavloKuzhelPrototypes: Prototype[] = [
  {
    id: "pk-faire-mcp-curation",
    name: "AI-native curation (Faire MCP demo)",
    path: "/pk/faire-mcp-curation",
    description:
      "Future Faire MCP server that lets retailers curate product lists from inside Claude or ChatGPT. Two flows: account-gated vs logged-out paywall.",
    owner: "Pavlo Kuzhel",
    createdAt: "2026-05-28",
    lastUpdated: "2026-05-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/5874c0a72a4624ddd98f93735e5c9296bdec1d55dbad34cd788d2bfe3f2b5419.png",
    creationTool: "claude-code",
  },
];
